import { PropsWithChildren, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useSession } from '../contexts/AuthContext';

type CallbackPageProps = {
  defaultReturnUrl?: string;
};

const CallbackPage: React.FC<PropsWithChildren<CallbackPageProps>> = ({
  defaultReturnUrl,
}) => {
  const { setUserCache } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tokens = params.get('tokens');
  const returnUrl = params.get('returnUrl') || defaultReturnUrl;

  useEffect(() => {
    if (tokens && returnUrl) {
      const redirectUrl = new URL(returnUrl).pathname
        .split('/')
        .slice(2)
        .join('/');

      setUserCache(JSON.parse(atob(tokens))).then(() =>
        navigate(`/${redirectUrl}`, { replace: true })
      );
    }
  }, [navigate, returnUrl, setUserCache, tokens]);

  return null;
};

export default CallbackPage;

export const callbackRoute = (
  path = 'callback',
  defaultReturnUrl = window.location.origin
) => ({
  path: path,
  element: <CallbackPage defaultReturnUrl={defaultReturnUrl} />,
});
